import { Navigate } from "react-router-dom";

export default function RedirectToGoals() {
  return <Navigate to="/discipline-manager" replace />;
}
